"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreOperationTypeEnum = void 0;
var BillingCoreOperationTypeEnum;
(function (BillingCoreOperationTypeEnum) {
  /** Операция оплаты */
  BillingCoreOperationTypeEnum["PAYMENT"] = "PAYMENT";
  /** Операция начисления авансов контрагентам сделки */
  BillingCoreOperationTypeEnum["CONTRACTORS_PREPAYMENT"] = "CONTRACTORS_PREPAYMENT";
  /** Операция зачёта авансов` */
  BillingCoreOperationTypeEnum["CONTRACTORS_PREPAYMENT_CONFIRM"] = "CONTRACTORS_PREPAYMENT_CONFIRM";
  /** Операция возврата */
  BillingCoreOperationTypeEnum["REFUND"] = "REFUND";
  /** Операция выплаты на внешний счёт */
  BillingCoreOperationTypeEnum["PAYOUT"] = "PAYOUT";
})(BillingCoreOperationTypeEnum = exports.BillingCoreOperationTypeEnum || (exports.BillingCoreOperationTypeEnum = {}));
